module.exports = __webpack_public_path__ + "img/44400.2561752b.jpg";